import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import {
  ThemeOptions,
  ThemeOverride,
} from '@wix/da-react-context/pkg/ThemeContext';
import { SubscriptionPurchaseFTUEContext } from './SubscriptionPurchaseFTUEContext';

import s from './SubscriptionPurchaseFTUE.scss';

export interface Props {
  className?: string;
}

const ILLUSTRATION_URL = Url.staticCDNLink(
  'eclipse/global/svg/congrats-ms-hexagon.svg'
);

/** Displays a ftue popup for viewers of in-tier deviations after
 *  their first time subscribing to a tier. */
export const SubscriptionPurchaseFTUE: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();

  const ftuePhase = useContext(SubscriptionPurchaseFTUEContext);
  const isShown = !!ftuePhase;
  if (!isShown) {
    return null;
  }

  return (
    <div
      className={classnames(
        s['root'],
        isMounted && s['mounted'],
        ftuePhase !== 'overlay' && s['fading-out'],
        className
      )}
    >
      <img className={s['illustration']} src={ILLUSTRATION_URL} alt="" />

      <section className={s['ftue-explanation']}>
        <h6 className={s['heading']}>
          {t('deviation.tier.ftue.subscriptionUnlocked.heading')}
        </h6>

        <p>{t('deviation.tier.ftue.subscriptionUnlocked.explanation')}</p>

        <ThemeOverride theme={ThemeOptions.DARK}>
          <TextButton
            className={s['got-it']}
            size="small"
            variant="approval-green"
          >
            {t('deviation.tier.ftue.subscriptionUnlocked.gotIt')}
          </TextButton>
        </ThemeOverride>
      </section>
    </div>
  );
};
SubscriptionPurchaseFTUE.displayName = 'SubscriptionPurchaseFTUE';

export default SubscriptionPurchaseFTUE;
